export default __webpack_public_path__ + "static/5-1f59f241fa17c5260a02b251b9313d72.jpg";